module.exports = __webpack_public_path__ + "static/media/junk-removal.5727affa.svg";